import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle"];

  connect() {
    this._onKeydown = (e) => { if (e.key === "Escape") this.close(); };
    window.addEventListener("keydown", this._onKeydown);
  }

  disconnect() {
    window.removeEventListener("keydown", this._onKeydown);
  }

  open(event) {
    const videoId = event.currentTarget.dataset.videoId;
    const frame = document.getElementById("video_drawer_frame");
    frame.setAttribute("src", `/videos/${videoId}/drawer`);
    this.toggleTarget.checked = true;
  }

  close() {
    this.toggleTarget.checked = false;
  }
}
